import React from "react";

import "./App.css";
import { Router } from "@reach/router";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Activations from "./pages/Activation";
import UserType from "./pages/UserType";
import IndividualRegistration from "./pages/IndividualRegistration";
import BusinessRegistration from "./pages/BusinessRegistration";
import LocationPicker from "./pages/LocationPicker";
import Thankyou from "./pages/Thankyou";
import IndustryCitySelect from "./pages/IndustryCitySelect";
import Scope from "./pages/Scope";
import ContactUs from "./pages/ContactUs";
import About from "./pages/About";
import Service from "./pages/Service";
import Service1 from "./pages/Service1";
import Service2 from "./pages/Service2";

function App() {
  return (
    <Router>
      <Home path="/" />
      <Scope path="/scope" />
      <ContactUs path="/contact_us" />
      <Service path="/service" />
      <Service1 path="/service1" />
      <Service2 path="/service2" />

      <About path="/about" />
      <Login path="/login/:userType" />
      <Activations path="/activations" />
      <UserType path="/usertype" />
      <IndividualRegistration path="/individual_registration" />
      <BusinessRegistration path="/business_registration" />
      <LocationPicker path="/location_picker" />
      <IndustryCitySelect  path="/industry_city" />
      <Thankyou  path="/thankyou" />
    </Router>
  );
}

export default App;
